import { useCallback, useState } from "react";
import { useToast } from "@/hooks/use-toast";
import { documentSharingService } from "@/services/documentSharingService";

export function useCopyPublicDocumentLink() {
  const { toast } = useToast();
  const [isCopying, setIsCopying] = useState(false);

  const copyPublicLink = useCallback(
    async (documentId: string) => {
      setIsCopying(true);
      try {
        const { url } = await documentSharingService.getOrCreatePublicLink(documentId);
        await navigator.clipboard.writeText(url);
        toast({
          title: "Public link copied",
          description: "Anyone with the link can view this note without signing in.",
        });
      } catch (error) {
        toast({
          title: "Failed to copy link",
          description: error instanceof Error ? error.message : "An error occurred",
          variant: "destructive",
        });
      } finally {
        setIsCopying(false);
      }
    },
    [toast]
  );

  return { copyPublicLink, isCopying };
}
